import React, { useEffect, useState, useRef } from 'react';
import { api } from '../api';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

function Judge() {
  const location = useLocation();
  const navigate = useNavigate();
  const { participantName, partyCode } = location.state || {};
  const [submissions, setSubmissions] = useState([]);
  const pollRef = useRef(null);
  const apiKey = process.env.REACT_APP_TMDB_API_KEY;

  const fetchSubmissions = async () => {
    try {
      const data = await api.getSubmissions(partyCode);

      const submissionsData = [];
      for (const row of data) {
        try {
          const movieResponse = await axios.get(
            `https://api.themoviedb.org/3/movie/${row.movie_id}`,
            { params: { api_key: apiKey } }
          );
          submissionsData.push({
            movie: movieResponse.data,
            name: row.name
          });
        } catch (error) {
          console.error('Error fetching movie details:', error);
        }
      }
      setSubmissions(submissionsData);
    } catch (error) {
      console.error('Error fetching submissions:', error);
    }
  };

  useEffect(() => {
    if (!partyCode || !participantName) {
      navigate('/');
      return;
    }

    // Set judge name
    api.updateParty(partyCode, { judge_name: participantName }).catch((err) =>
      console.error('Error setting judge name:', err)
    );

    // Initial fetch
    fetchSubmissions();

    // Poll for new submissions (replaces Supabase Realtime)
    pollRef.current = setInterval(fetchSubmissions, 3000);

    return () => clearInterval(pollRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyCode, participantName, navigate]);

  const handleSelectMovie = async (submission) => {
    try {
      const response = await axios.get(
        `https://api.themoviedb.org/3/movie/${submission.movie.id}/watch/providers`,
        { params: { api_key: apiKey } }
      );
      const providers = response.data.results.US || response.data.results.GB || null;

      await api.updateParty(partyCode, {
        winner: {
          movie: submission.movie,
          submitter: submission.name,
          watchProviders: providers
        }
      });

      navigate('/winner', {
        state: {
          movie: submission.movie,
          submitter: submission.name,
          partyCode: partyCode,
          watchProviders: providers
        },
        replace: true
      });
    } catch (error) {
      console.error('Error selecting winner:', error);
    }
  };

  return (
    <div className="home-container scroll-container">
      <div className="header-section">
        <h1>Judge View</h1>
        <p>{submissions.length} movie{submissions.length !== 1 ? 's' : ''} submitted</p>
      </div>

      <div className="submissions-list">
        {submissions.map((submission, index) => (
          <div key={index} className="submission-card" onClick={() => handleSelectMovie(submission)}>
            <img
              src={submission.movie.poster_path
                ? `https://image.tmdb.org/t/p/w200${submission.movie.poster_path}`
                : '/na.png'
              }
              alt={submission.movie.title}
              className="movie-poster"
            />
            <div className="movie-info">
              <h3>{submission.movie.title} ({submission.movie.release_date?.split('-')[0] || 'N/A'})</h3>
              {/* name hidden from judge */}
              <p className="overview">{submission.movie.overview}</p>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .submissions-list {
          display: grid;
          gap: 15px;
          width: 100%;
          margin-top: 10px;
        }

        .submission-card {
          display: flex;
          gap: 15px;
          padding: 15px;
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.3);
          cursor: pointer;
          border: 2px solid transparent;
          transition: border-color 0.2s ease;
        }

        .submission-card:hover {
          border-color: #FF4040;
        }

        .movie-poster {
          width: 130px;
          height: 195px;
          border-radius: 4px;
          object-fit: cover;
          box-shadow: 0 2px 5px rgba(0,0,0,0.3);
        }

        .movie-info {
          flex: 1;
        }

        .movie-info h3 {
          margin: 0;
          font-size: 18px;
          color: #333;
        }

        .submitter {
          color: #FF4040;
          margin: 5px 0;
          font-size: 14px;
        }

        .overview {
          color: #666;
          font-size: 12px;
          line-height: 1.4;
        }
      `}</style>
    </div>
  );
}

export default Judge;
